var scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
  setTimeout(function () {
    loadScript("//www.naturespell.in/cdn/shop/t/22/assets/dynamic-reel-video-section.js?v=143830338466493366041765913496");
    loadScript("//www.naturespell.in/cdn/shop/t/22/assets/quantity-popover.js?v=987015268078116491765913496");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/component-card.css?v=120341546515895839841765913498");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/component-cart.css?v=164708765130180853531765913500");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/component-cart-items.css?v=13033300910818915211765913499");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/component-totals.css?v=15906652033866631521765913496");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/component-price.css?v=47596247576480123001765913495");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/component-discounts.css?v=152760482443307489271765913494");
    loadCSS("//www.naturespell.in/cdn/shop/t/22/assets/quantity-popover.css?v=160630540099520878331765913496");
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mousemove', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts({ type: 'initialScroll', isTrusted: true });
} else {
  document.addEventListener('scroll', loadScripts);
  document.addEventListener('mousemove', loadScripts);
  document.addEventListener('click', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}